import { Time } from '../../../../../../../types/time'
import { format } from 'date-fns'
import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { TowingRecordJobStatus } from '../../../../../../../common/types'
import { Button } from '../../../../../../../components/Button'
import { CollapseContent } from '../../../../../../../components/Collapse/CollapseContent'
import { RouteColumn, RouteRow } from '../../../../../../../components/layout'
import { ArrivalDateTimeInput } from '../../../../../../../components/layout/form/input/DateTimeInput'
import { LocationInputMap, toMapData } from '../../../../../../../components/layout/form/input/LocationInputMap'
import React from 'react'
import { ArrivedAtDestinationProps, DefaultProps } from './ArrivedForm'

export const ArrivedAtDestinationForm: React.FunctionComponent<ArrivedAtDestinationProps & DefaultProps> = ({
  clear,
  getValue,
  setValue,
  action,
  stationId = null,
  setRouteLocation
}) => {
  const [edit, setEdit] = useState<boolean>(action === 'edit-arrived')

  useEffect(() => {
    if (action === 'edit-arrived') {
      if (!edit) setEdit(true)
    } else {
      if (edit) setEdit(false)
    }
  }, [edit, action, setEdit])

  return (
    <>
      <CollapseContent>
        <RouteRow columns={`2fr 1fr`}>
          <RouteColumn>
            <LocationInputMap
              addressLabel={'Osoite'}
              addressName={`finishRoute.address`}
              cityLabel={`Kaupunki`}
              cityName={`finishRoute.city`}
              coordsName={`finishRoute.coords`}
              zipcodeName={`finishRoute.zipcode`}
              descriptionName={`finishRoute.description`}
              required={edit}
              coordsRequired={edit}
              disabled={!edit}
              getValue={getValue}
              setRouteLocation={setRouteLocation}
              values={toMapData(
                getValue(`finishRoute.address`),
                getValue(`finishRoute.city`),
                getValue(`finishRoute.coords`),
                getValue(`finishRoute.zipcode`)
              )}
              setValue={setValue}
              includeNameInAddress={false}
              stationId={stationId}
              clear={clear}
            />
          </RouteColumn>
          <RouteColumn>
            <ArrivalDateTimeInput
              label="Saapumisaika"
              name={`finishRoute`}
              customOnChange={() => {
                const value = (format(new Date(), 'HH:mm') as unknown) as Time
                setValue('finishRoute.arrivalDate', new Date())
                setValue('finishRoute.arrivalTime', value)
              }}
              required={edit}
              disabled={!edit}
              showCurrentTimeBtn
            />
          </RouteColumn>
        </RouteRow>
      </CollapseContent>
    </>
  )
}

export const arrivedAtDestinationEditableJobStatuses = [
  TowingRecordJobStatus.arrived_at_destination,
  TowingRecordJobStatus.finished_at_destination,
]

export const CustomButton = styled(Button as any)`
  margin-right: 1rem;
`
